import axios from "axios";
import { requestInterceptors, responseInterceptors } from "api";

const afmsBaseURL = process.env.REACT_APP_AFMS_API_URL || process.env.REACT_APP_API_URL;

const afmsApiInstance = axios.create({
  baseURL: afmsBaseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

afmsApiInstance.interceptors.request.use(...requestInterceptors);
afmsApiInstance.interceptors.response.use(...responseInterceptors);

export default afmsApiInstance;

// Re-export flex2's specialized instances (not used by AFMS services today, kept for compatibility)
export { apiInstanceFileUpload, cachedApiInstance } from "api";
